import { render, staticRenderFns } from "./UniversalDialog.vue?vue&type=template&id=f4d75d22&scoped=true&"
import script from "./UniversalDialog.vue?vue&type=script&lang=js&"
export * from "./UniversalDialog.vue?vue&type=script&lang=js&"
import style0 from "./UniversalDialog.vue?vue&type=style&index=0&id=f4d75d22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4d75d22",
  null
  
)

export default component.exports